<template>
    <v-container>
        <v-row :class="$vuetify.breakpoint.mobile ? '' : 'd-flex flex-nowrap'">
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 9">
                <v-subheader class="d-flex justify-center">Edit</v-subheader>
                <ts-nft-create-form @mounted="v => this.$set(this, 'form', v)"
                                    :wallet="wallet"
                                    :startTour="startTour"
                                    @created="createdHandler"
                                    @reset="resetHandler"
                                    @example="() => overlays.example = true"
                                    @unverified="unverifiedHandler"
                                    @step="stepNumber => step = stepNumber" :wallet_account="wallet_account"></ts-nft-create-form>
            </v-col>
            <v-col id="tour-step-progress" :class="$vuetify.breakpoint.mobile ? 'pa-0' : ''" :cols="$vuetify.breakpoint.mobile ? 12 : 3">
                <v-subheader class="d-flex justify-center">Progress</v-subheader>
                <ts-nft-create-progress :class="$vuetify.breakpoint.mobile ? 'pa-0' : ''" v-show="form" :form="form" :step="step" :nft="nft" @reset="reset = false" :reset="reset"></ts-nft-create-progress>
            </v-col>
        </v-row>
        <v-overlay id="example-overlay" :dark="false" :value="overlays.example" absolute>
            <ts-nft-example v-click-outside="onClickOutside" v-if="overlays.example"></ts-nft-example>
        </v-overlay>
        <v-overlay id="unverified-overlay" :dark="false" :value="overlays.unverified" absolute>
            <v-card class="mx-auto" min-width="75%">
                <v-card-title class="font-weight-light text-h5">
                    Choose a username.
                </v-card-title>
                <v-card-subtitle class="mt-4">
                    Please be sure you like your choice as it cannot be changed later. You may use the <i>different</i> button for more options.
                </v-card-subtitle>

                <v-card-text class="mb-4">
                    All BraNFT™ users have distinct usernames and are verified against social media<sup class="ml-2">
                        <router-link style="text-decoration: none" :to="{ name: 'faq', query: { category: 'branft', id: '61f01804accc01000142b9fa' }}">(Learn More)</router-link>
                    </sup>
                    <p>To be clear, creating BraNFTs is a feature strictly available for the actual original owners of bras (women) only.</p>
                    <v-list-item dense class="text-center" v-for="(username, i)  of usernames" v-bind:key="username">
                        <v-list-item-content class="py-0" style="overflow: visible">
                            <v-list-item-title style="overflow: visible">
                                <ts-username :setFirstLoad="setFirstLoad" @chosen="(username) => { chosenUsername = username }" :index="i" :chosen="chosenUsername" font="allura" :username="username" :delay="(Math.ceil(Math.random() * 3)) * 200"></ts-username>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                           color="primary"
                           text
                           @click="getAvailableUsernames">
                        Different
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                           color="primary"
                           text
                           @click="signupButtonHandler">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </v-container>
</template>
<style>
.allura {
    font-family: "Allura", cursive;
    font-size: xx-large;
}
</style>
<script>
import TsNftCreateForm from "./TsNftCreateForm.vue";
import TsNftCreateProgress from "./TsNftCreateProgress";
import TsNftExample from "./TsNftExample.vue";
import TsUsername from "../components/TsUsername.vue";

export default {
    name: "TsNftCreatePanel",
    components: {
        TsNftCreateForm,
        TsNftCreateProgress,
        TsNftExample,
        TsUsername,
    },
    props: {
        wallet_account: Object,
    },
    data: function () {
        return {
            overlays: {
                example: false,
                unverified: false,
            },
            form: null,
            premint_id: process.env.VUE_APP_EXAMPLE_PREMINT_ID,
            NODE_ENV: process.env.NODE_ENV,
            nft: null,
            usernames: null,
            chosenUsername: null,
            reset: false,
            step: null,
        };
    },
    methods: {
        resetHandler() {
            this.reset = true;
            this.step = 1;
        },
        onClickOutside: function () {
            this.overlays.example = false;
        },
        createdHandler: function (nft) {
            this.nft = nft;
        },
        signup() {
            // eslint-disable-next-line no-constant-condition
            if (false && this.$auth.isAuthenticated) {
                this.$router.push("/account");
            } else {
                this.getAvailableUsernames();
            }
        },
        async getAvailableUsernames() {
            this.setFirstLoad = { bool: true };
            this.$set(
                this,
                "usernames",
                await this.$backend.getAvailableUsernames(3)
            );
            this.setFirstLoad = {
                bool: false,
                delay: [
                    "animate__delay-2s",
                    "animate__delay-3s",
                    "animate__delay-4s",
                ],
            };
        },
        signupButtonHandler: async function () {
            await this.$auth.loginWithPopup({
                screen_hint: "signup",
                appState: { targetUrl: this.$route.fullPath },
                username_hint: this.chosenUsername,
            });
            this.$router.push({ path: "/account#nft-create?welcome=braNFT" });
        },
        unverifiedHandler() {
            if (!document.location.hostname.match(/branfts/)) {
                this.overlays.unverified = true;
            }
        },
    },
    computed: {
        startTour() {
            return this.$attrs.currentProperties
                ? this.$attrs.currentProperties.startTour
                : undefined;
        },
        wallet() {
            return this.$attrs.currentProperties
                ? this.$attrs.currentProperties.wallet
                : undefined;
        },
    },
    mounted() {
        global.resetHandler = this.resetHandler;
    },
};
</script>
